// The admin campaign form: filter, count and clear each scope list, and show
// the discount terms only for a discount. Keyed on form[data-promotion-form],
// which only admin/promotions/_form renders, so it is inert everywhere else.
//
// Enhancement only. With no pack the boxes still post, the filter stays
// hidden, and the discount fieldset stays visible as it always was.

function setupScopeList(list) {
  const boxes = Array.from(list.querySelectorAll('input[type="checkbox"]'));
  const count = list.querySelector("[data-scope-count]");
  const clear = list.querySelector("[data-scope-clear]");
  const filter = list.querySelector("[data-scope-filter]");

  function recount() {
    const n = boxes.filter((box) => box.checked).length;
    if (count) count.textContent = n ? `${n} chosen` : "Any";
  }

  list.addEventListener("change", recount);

  if (clear) {
    clear.addEventListener("click", () => {
      boxes.forEach((box) => {
        box.checked = false;
      });
      recount();
    });
  }

  if (filter) {
    const empty = list.querySelector("[data-scope-empty]");
    filter.hidden = false;
    filter.addEventListener("input", () => {
      const term = filter.value.trim().toLowerCase();
      let anyShown = false;
      list.querySelectorAll("[data-scope-group]").forEach((group) => {
        let shown = 0;
        group.querySelectorAll(".form-check").forEach((row) => {
          const match = !term || row.textContent.toLowerCase().includes(term);
          row.hidden = !match;
          if (match) shown += 1;
        });
        // A heading that matches keeps its whole group, so "UCC" finds every
        // UCC programme.
        const heading = group.querySelector(".scope-list__heading");
        const headingMatch = term && heading && heading.textContent.toLowerCase().includes(term);
        if (headingMatch) {
          group.querySelectorAll(".form-check").forEach((row) => {
            row.hidden = false;
          });
        }
        group.hidden = !(shown || headingMatch);
        if (!group.hidden) anyShown = true;
      });
      if (empty) empty.hidden = anyShown;
    });
  }
}

function setupKind(form) {
  const kind = form.querySelector('select[name="promotion[kind]"]');
  if (!kind || kind.disabled) return;

  const capLabel = form.querySelector("[data-cap-label]");
  function apply() {
    form.querySelectorAll("[data-kind-only]").forEach((el) => {
      el.hidden = el.dataset.kindOnly !== kind.value;
    });
    if (capLabel) capLabel.textContent = kind.value === "discount" ? "Cap on checkouts" : "Cap on covers";
  }
  kind.addEventListener("change", apply);
  apply();
}

function setup() {
  const form = document.querySelector("form[data-promotion-form]");
  if (!form) return;

  form.querySelectorAll("[data-scope-list]").forEach(setupScopeList);
  setupKind(form);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setup);
} else {
  setup();
}
